let getters = {
    // 购物车所有数据
    cartData: state => state.cartData,
    // 购物车所有商品列表
    cartList: state => state.cartList,
    // 顶部提示信息是否显示
    isTipsShow: state => state.isTipsShow,
    // 购物车有效商品列表
    validCartList: state => {
        return state.cartList.filter(item => {
            return item.inventoryStatus !== 2 && !item.isAuction && !item.isAuctionProduct && !item.isUpAuction;
        });
    },
    // 购物车无效商品列表
    invalidCartList: state => {
        return state.cartList.filter(item => {
            // 无库存、竞拍商品、正价拍商品为无效商品
            return item.inventoryStatus === 2 || item.isAuction || item.isAuctionProduct || item.isUpAuction;
        });
    },
    // 是否显示税金的遮罩
    isTaxMaskShow: state => state.isTaxMaskShow,
    // 用户upk
    upk: state => state.upk,
    // 是否显示toast提示框
    isToastShow: state => state.isToastShow,
    // toast提示框文字
    toastDesc: state => state.toastDesc,
    // 是否为编辑状态
    isEdit: state => state.isEdit,
    // 是否显示loading状态图标
    isLoadingShow: state => state.isLoadingShow,
    // 是否显示confirm弹窗
    isConfirmShow: state => state.confirm.isShow,
    // confirm数据
    confirmData: state => state.confirm.data

};

export default getters;



// WEBPACK FOOTER //
// ./src/store/getters.js